import { render, staticRenderFns } from "./friendRequest.vue?vue&type=template&id=4b256cc1&scoped=true&lang=pug&"
import script from "./friendRequest.vue?vue&type=script&lang=js&"
export * from "./friendRequest.vue?vue&type=script&lang=js&"
import style0 from "./friendRequest.vue?vue&type=style&index=0&id=4b256cc1&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b256cc1",
  null
  
)

export default component.exports